import { useEffect } from 'react';
import SaleQRCode from '../admin/components/sales/SaleQRCode';

const CY = '#90E0EF';
export const CARD_BUY_URL = 'https://therelativegallery.com/cards/buy';

// Print-friendly poster for the permanent card-sale QR. Opened in its own tab
// from the admin CARD SALE overlay; uses browser-native printing.
export default function CardQRPrintPage() {
  useEffect(() => {
    document.title = 'Mr. Relative — Card Editions QR';
  }, []);

  return (
    <div className="min-h-[100svh] bg-white flex items-center justify-center p-8 print:p-0" data-testid="card-qr-print-page">
      <style>{`
        @media (hover: hover) {
          [data-testid="card-qr-print-page"], [data-testid="card-qr-print-page"] * { cursor: auto !important; }
          [data-testid="card-qr-print-page"] button { cursor: pointer !important; }
        }
        @media print { @page { margin: 12mm; } .no-print { display: none !important; } body { background: #fff; } }
      `}</style>

      <div className="w-full max-w-[420px]">
        <div className="bg-[#050505] text-white px-10 py-12 text-center" style={{ WebkitPrintColorAdjust: 'exact', printColorAdjust: 'exact' }}>
          <p className="text-[11px] font-mono uppercase tracking-[0.34em]" style={{ color: CY }}>Mr. Relative</p>
          <h1 className="font-outfit font-bold tracking-tight mt-3" style={{ fontSize: '2rem', lineHeight: 1.05 }}>Card Editions</h1>
          <p className="text-xs font-mono text-[#bbb] mt-3">£20 per physical card</p>

          <div className="my-9 flex justify-center">
            <div className="p-3" style={{ background: '#050505', border: `1px solid rgba(144,224,239,0.3)` }}>
              <SaleQRCode value={CARD_BUY_URL} size={240} />
            </div>
          </div>

          <p className="text-[11px] font-mono uppercase tracking-[0.24em] text-white">Scan to buy your cards</p>
          <p className="text-[11px] font-mono mt-2" style={{ color: CY }}>therelativegallery.com/cards/buy</p>
        </div>

        <button onClick={() => window.print()} data-testid="print-now-btn"
          style={{ cursor: 'pointer', background: '#050505', color: '#fff' }}
          className="no-print mt-6 w-full py-3.5 text-[11px] font-mono uppercase tracking-[0.22em]">
          Print this QR
        </button>
      </div>
    </div>
  );
}
